import {IRootState} from '../root-state.interface';

export const selectLanguage = (state: IRootState) => state.language.language;

export const selectShowBlock = (state: IRootState) => state.language.language === 'ru';
